'use strict';
var BASWebServices;
(function (BASWebServices) {
    var ShortenFilter = (function () {
        function ShortenFilter() {
        }
        ShortenFilter.Factory = function () {
            return function (input) {
                if (input == null) {
                    return input;
                }
                else if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(ShortenFilter.filter(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return ShortenFilter.filter(input);
                }
                else if (input === 'undefined') {
                    return 0;
                }
                else if (input === undefined) {
                    return 0;
                }
                else if (input.toString().lastIndexOf("http://") != -1 ||
                    input.toString().lastIndexOf("https://") != -1) {
                    return ShortenFilter.filter(input.toString());
                }
                else {
                    return input;
                }
            };
        };
        ShortenFilter.filter = function (inputString) {
            var outputString = "";
            var lowCutIndex = 5;
            var highCutOffset = 7;
            if (inputString.length == 14) {
                lowCutIndex = 6;
                highCutOffset = 7;
            }
            else if (inputString.length >= 15) {
                lowCutIndex = 6;
                highCutOffset = 8;
            }
            if (inputString.length > 13) {
                outputString = inputString.substring(0, lowCutIndex);
                outputString += "...";
                outputString += inputString.substring(inputString.length - highCutOffset);
            }
            else {
                outputString = inputString;
            }
            return outputString;
        };
        return ShortenFilter;
    }());
    BASWebServices.ShortenFilter = ShortenFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ShortenFilter.js.map